import Vue from 'vue'
import lodash from 'lodash'
import dayjs from 'dayjs'

Vue.prototype.$lodash = lodash
Vue.prototype.$dayjs = dayjs
